import { Package, Camera, Landmark, Users, Lock, MessageSquare } from 'lucide-react';
import { useReveal } from '@/lib/useReveal';
import { Section, Container, Display, Stat, Tile } from '@/components/system';

/**
 * Highlights — bento tiles. Specific numbers over adjectives (Brand voice: "15 provincias,
 * 168 municipios" before "cobertura amplia").
 */
const tiles = [
  { icon: Package, title: 'Rastreo artículo por artículo.', text: 'No un estado genérico: cada cosa que viaja tiene su propia línea de tiempo, con fecha por etapa.' },
  { icon: Camera, title: 'Entrega comprobada.', text: 'Foto, firma del receptor y GPS en cada entrega — visibles para la agencia y para el cliente.' },
  { icon: Landmark, title: 'Aduana inteligente.', text: 'El arancel oficial cubano integrado: cargos por paquete y consulta desde la app de tus clientes.' },
  { icon: Users, title: 'Permisos por empleado.', text: 'Cada quien ve y hace solo lo que le corresponde. Sucursales ilimitadas bajo una sola cuenta.' },
  { icon: MessageSquare, title: 'Una sola bandeja.', text: 'Todos los chats de tus clientes en un lugar, y un chat interno para tu equipo, separado.' },
  { icon: Lock, title: 'Cifrado y auditoría.', text: 'Datos personales cifrados en reposo y un registro de cambios que nadie puede borrar.' },
];

export function Coverage() {
  const ref = useReveal<HTMLElement>();
  return (
    <Section tone="grey" ref={ref}>
      <Container>
        <div className="max-w-3xl">
          <p data-reveal className="text-brand font-semibold text-base sm:text-lg mb-4">Lo esencial</p>
          <Display data-reveal size="lg">Todo lo que tu agencia necesita. Nada que no.</Display>
        </div>

        {/* numbers */}
        <div data-reveal className="mt-12 rounded-[28px] bg-white p-8 sm:p-10 grid sm:grid-cols-3 gap-8">
          <Stat value="15" label="provincias de Cuba" />
          <Stat value="168" label="municipios en el sistema" />
          <Stat value="232" label="partidas del arancel integradas" />
        </div>

        <div className="mt-5 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {tiles.map((t) => (
            <Tile key={t.title} data-reveal>
              <div className="w-11 h-11 rounded-xl bg-brand/10 flex items-center justify-center">
                <t.icon className="w-5 h-5 text-brand" />
              </div>
              <h3 className="mt-6 font-heading text-xl sm:text-2xl font-semibold tracking-tight">{t.title}</h3>
              <p className="mt-3 text-text-secondary leading-relaxed">{t.text}</p>
            </Tile>
          ))}
        </div>
      </Container>
    </Section>
  );
}
